<template>
  <div class="myOrder">
    <div class="top">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="first">
          <div class="sub-main" v-loading="loading">
            <a-table :columns="columns" :data-source="receiveList" bordered :pagination="false" >
              <template slot="state" slot-scope="val">
                <!-- 状态0待收货 1待审核 2待付款 3已完成 默认为0 -->
                <a v-if="val == 0">待收货</a>
                <a v-else-if="val == 1">待审核</a>
                <a v-else-if="val == 2">待补款</a>
                <a v-else-if="val == 3">已完成</a>
                <a v-else-if="val == 4">被驳回</a>
                <a v-else>{{val}}</a>
              </template>
              <template slot="operation" slot-scope="val,record">
                <a-button type="primary" v-if="record.state == 0" @click="showDialog(record)">去确认</a-button>
                <a-button type="primary" v-if="record.state == 4" @click="showDialog(record)">重新确认</a-button>
                <a-button v-if="record.state == 1" @click="showDialog(record)">查看详情</a-button>
                <a-button type="primary" v-if="record.state == 2" @click="showDialog(record)">去补款</a-button>
                <a-button v-if="record.state == 3" @click="showDialog(record)">查看详情</a-button>
              </template>
            </a-table>
            <div class="paginationBox"><a-pagination @change="onChange" :total="total" v-if="total > 10"/></div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label">
            <el-badge :value="checkStateCounts['0']" :hidden="!checkStateCounts['0']" class="item specialBadge">
              待收货
            </el-badge>
          </span>
          <div class="sub-main" v-loading="loading">
            <a-table :columns="columns" :data-source="receiveList" bordered :pagination="false">
              <template slot="state" slot-scope="val">
                <!-- 状态0待收货 1待审核 2待付款 3已完成 默认为0 -->
                <a v-if="val == 0">待收货</a>
                <a v-else-if="val == 1">待审核</a>
                <a v-else-if="val == 2">待补款</a>
                <a v-else-if="val == 3">已完成</a>
                <a v-else-if="val == 4">被驳回</a>
                <a v-else>{{val}}</a>
              </template>
              <template slot="operation" slot-scope="val,record">
                <a-button type="primary" v-if="record.state == 0" @click="showDialog(record)">去确认</a-button>
                <a-button type="primary" v-if="record.state == 4" @click="showDialog(record)">重新确认</a-button>
                <a-button v-if="record.state == 1" @click="showDialog(record)">查看详情</a-button>
                <a-button type="primary" v-if="record.state == 2" @click="showDialog(record)">去补款</a-button>
                <a-button v-if="record.state == 3" @click="showDialog(record)">查看详情</a-button>
              </template>
            </a-table>
            <div class="paginationBox"><a-pagination @change="onChange" :total="total" v-if="total > 10"/></div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="third">
          <span slot="label">
            <el-badge :value="checkStateCounts['1']" :hidden="!checkStateCounts['1']" class="item specialBadge">
              待商家确认
            </el-badge>
          </span>
          <div class="sub-main" v-loading="loading">
            <a-table :columns="columns" :data-source="receiveList" bordered :pagination="false">
              <template slot="state" slot-scope="val">
                <!-- 状态0待收货 1待审核 2待付款 3已完成 默认为0 -->
                <a v-if="val == 0">待收货</a>
                <a v-else-if="val == 1">待审核</a>
                <a v-else-if="val == 2">待补款</a>
                <a v-else-if="val == 3">已完成</a>
                <a v-else-if="val == 4">被驳回</a>
                <a v-else>{{val}}</a>
              </template>
              <template slot="operation" slot-scope="val,record">
                <a-button type="primary" v-if="record.state == 0" @click="showDialog(record)">去确认</a-button>
                <a-button type="primary" v-if="record.state == 4" @click="showDialog(record)">重新确认</a-button>
                <a-button v-if="record.state == 1" @click="showDialog(record)">查看详情</a-button>
                <a-button type="primary" v-if="record.state == 2" @click="showDialog(record)">去补款</a-button>
                <a-button v-if="record.state == 3" @click="showDialog(record)">查看详情</a-button>
              </template>
            </a-table>
            <div class="paginationBox"><a-pagination @change="onChange" :total="total" v-if="total > 10"/></div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="four">
          <span slot="label">
            <el-badge :value="checkStateCounts['2']" :hidden="!checkStateCounts['2']" class="item specialBadge">
              待付款
            </el-badge>
          </span>
          <div class="sub-main" v-loading="loading">
            <a-table :columns="columns" :data-source="receiveList" bordered :pagination="false">
              <template slot="state" slot-scope="val">
                <!-- 状态0待收货 1待审核 2待付款 3已完成 默认为0 -->
                <a v-if="val == 0">待收货</a>
                <a v-else-if="val == 1">待审核</a>
                <a v-else-if="val == 2">待补款</a>
                <a v-else-if="val == 3">已完成</a>
                <a v-else-if="val == 4">被驳回</a>
                <a v-else>{{val}}</a>
              </template>
              <template slot="operation" slot-scope="val,record">
                <a-button type="primary" v-if="record.state == 0" @click="showDialog(record)">去确认</a-button>
                <a-button type="primary" v-if="record.state == 4" @click="showDialog(record)">重新确认</a-button>
                <a-button v-if="record.state == 1" @click="showDialog(record)">查看详情</a-button>
                <a-button type="primary" v-if="record.state == 2" @click="showDialog(record)">去补款</a-button>
                <a-button v-if="record.state == 3" @click="showDialog(record)">查看详情</a-button>
              </template>
            </a-table>
            <div class="paginationBox"><a-pagination @change="onChange" :total="total" v-if="total > 10"/></div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="five">
          <span slot="label">
            <el-badge :value="checkStateCounts['3']" :hidden="!checkStateCounts['3']" class="item specialBadge">
              已完成
            </el-badge>
          </span>
          <div class="sub-main" v-loading="loading">
            <a-table :columns="columns" :data-source="receiveList" bordered :pagination="false">
              <template slot="state" slot-scope="val">
                <!-- 状态0待收货 1待审核 2待付款 3已完成 默认为0 -->
                <a v-if="val == 0">待收货</a>
                <a v-else-if="val == 1">待审核</a>
                <a v-else-if="val == 2">待补款</a>
                <a v-else-if="val == 3">已完成</a>
                <a v-else-if="val == 4">被驳回</a>
                <a v-else>{{val}}</a>
              </template>
              <template slot="operation" slot-scope="val,record">
                <a-button type="primary" v-if="record.state == 0" @click="showDialog(record)">去确认</a-button>
                <a-button type="primary" v-if="record.state == 4" @click="showDialog(record)">重新确认</a-button>
                <a-button v-if="record.state == 1" @click="showDialog(record)">查看详情</a-button>
                <a-button type="primary" v-if="record.state == 2" @click="showDialog(record)">去补款</a-button>
                <a-button v-if="record.state == 3" @click="showDialog(record)">查看详情</a-button>
              </template>
            </a-table>
            <div class="paginationBox"><a-pagination @change="onChange" :total="total" v-if="total > 10"/></div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="six">
          <span slot="label">
            <el-badge :value="checkStateCounts['4']" :hidden="!checkStateCounts['4']" class="item specialBadge">
              被驳回
            </el-badge>
          </span>
          <div class="sub-main" v-loading="loading">
            <a-table :columns="columns" :data-source="receiveList" bordered :pagination="false">
              <template slot="state" slot-scope="val">
                <!-- 状态0待收货 1待审核 2待付款 3已完成 默认为0 -->
                <a v-if="val == 0">待收货</a>
                <a v-else-if="val == 1">待审核</a>
                <a v-else-if="val == 2">待补款</a>
                <a v-else-if="val == 3">已完成</a>
                <a v-else-if="val == 4">被驳回</a>
                <a v-else>{{val}}</a>
              </template>
              <template slot="operation" slot-scope="val,record">
                <a-button type="primary" v-if="record.state == 0" @click="showDialog(record)">去确认</a-button>
                <a-button type="primary" v-if="record.state == 4" @click="showDialog(record)">重新确认</a-button>
                <a-button v-if="record.state == 1" @click="showDialog(record)">查看详情</a-button>
                <a-button type="primary" v-if="record.state == 2" @click="showDialog(record)">去补款</a-button>
                <a-button v-if="record.state == 3" @click="showDialog(record)">查看详情</a-button>
              </template>
            </a-table>
            <div class="paginationBox"><a-pagination @change="onChange" :total="total" v-if="total > 10"/></div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="search">
        <el-input placeholder="下单企业名称" v-model="formInline.recName" class="input-with-select">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="formInline.page = 1;getReceiveList();"
          ></el-button>
        </el-input>
      </div>
    </div>
    <a-modal
      v-model="visible"
      title="收货单"
      @ok="handleOk"
      :width="1100"
      :okText="curRow.state == 2 ? '补款' : '确定'"
      :ok-button-props="{ props: { disabled: curRow.state == 2 && curRow.checkerType == 1 } }"
    >
      <a-row>
        <a-col :span="6">
          <span class="miniLabel">收货单位:</span>
          <span class="miniText">{{curRow.recName}}</span>
        </a-col>
        <a-col :span="6">
          <span class="miniLabel">订单编号:</span>
          <span class="miniText">{{curRow.orderFormid}}</span>
        </a-col>
        <a-col :span="12">
          <span class="miniLabel">收货地址:</span>
          <span class="miniText">{{curRow.recAddr + ' ' + curRow.supplierAddr}}</span>
        </a-col>
        <a-col :span="6">
          <span class="miniLabel">联系人:</span>
          <span class="miniText">{{curRow.recContact}}</span>
        </a-col>
        <a-col :span="6">
          <span class="miniLabel">联系电话:</span>
          <span class="miniText">{{curRow.recPhone}}</span>
        </a-col>
        <a-col :span="12">
          <span class="miniLabel">下单时间:</span>
          <span class="miniText">{{curRow.orderCreateTime}}</span>
        </a-col>
      </a-row>
      <!-- details -->
      <a-table :columns="curRow.checkerType == 0 ? dialogColumns : dialogColumns_copy" :data-source="curRow.details" bordered :pagination="false">
        <template slot="checkNumber" slot-scope="val,row">
          <div v-if="row.useDecimal">
            <el-input-number
              v-if="curRow.state == 0 || curRow.state == 4"
              :value="val"
              @change="handleChange($event,row)"
              :min="0"
              :precision="2"
              :step="0.01"
            ></el-input-number>
            <span v-else>{{val}}</span>
          </div>
          <div v-else>
            <el-input-number
              v-if="curRow.state == 0 || curRow.state == 4"
              :value="val"
              @change="handleChange($event,row)"
              :min="0"
            ></el-input-number>
            <span v-else>{{val}}</span>
          </div>
        </template>
      </a-table>
      <div class="moneyInfo" v-if="curRow.checkerType == 0">
        <span>应付金额总计</span>
        <span>{{(curRow.supplyAmount + Number(curRowFinalPrice)).toFixed(2)}}</span>
        <span>首次已付金额</span>
        <span>{{curRow.supplyAmount}}</span>
        <template v-if="Number(curRowFinalPrice) != 0">
          <span>{{Number(curRowFinalPrice) >= 0 ? (curRow.state == 3 ? '已补款金额' : '需补款金额') : (curRow.state == 3 ? '已退款金额' : '需退款金额')}}</span>
          <span>{{Math.abs(Number(curRowFinalPrice)).toFixed(2)}}</span>
        </template>
      </div>
      <div class="peopleInfo" v-if="curRow.state == 1 || curRow.state == 3 ">
        <span>签收人</span>
        <div>{{curRow.checkerName || '暂无'}}</div>
        <span>签收日期</span>
        <div>{{curRow.checkTime || '暂无'}}</div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import api from "../../../api";
import { listSearchMixin } from "../../../config/mixin";
export default {
  mixins: [listSearchMixin],
  name: "myOrder",
  data() {
    return {
      visible: false,
      checkStateCounts:{},
      formInline: {
        page: 1,
        pageSize: 10
      },
      receiveList: [],
      dialogColumns: [
        {
          title: "货品名称",
          dataIndex: "productName",
          key: "productName"
        },
        {
          title: "规格",
          dataIndex: "value",
          key: "value",
          align: "center"
        },
        {
          title: "单价",
          dataIndex: "unitPrice",
          key: "unitPrice",
          align: "center"
        },
        {
          title: "应收数量",
          dataIndex: "number",
          key: "number",
          align: "center"
        },
        {
          title: "实收数量",
          dataIndex: "checkNumber",
          key: "checkNumber",
          scopedSlots: { customRender: "checkNumber" },
          align: "center"
        },
        {
          title: "应收小计",
          dataIndex: "amount",
          key: "amount",
          align: "center"
        },
        {
          title: "实收小计",
          dataIndex: "checkAmount",
          key: "checkAmount",
          scopedSlots: { customRender: "checkAmount" },
          align: "center"
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
          customRender: (val,row,index)=>{
            return {
              children: (this.curRow.state == 0  || this.curRow.state == 4) ? <a-textarea onChange={(val)=>{this.remarkChange(val,row)}} v-model={this.curRow.remark} placeholder="请输入备注" auto-size={{minRows: this.curRow.details.length * 3}}/> : <span>{this.curRow.remark}</span>,
              attrs:{
                rowSpan:index == 0 ? this.curRow.details.length : 0
              }
            }
          },
        }
      ],
      dialogColumns_copy: [
        {
          title: "货品名称",
          dataIndex: "productName",
          key: "productName"
        },
        {
          title: "规格",
          dataIndex: "value",
          key: "value",
          align: "center"
        },
        {
          title: "应收数量",
          dataIndex: "number",
          key: "number",
          align: "center"
        },
        {
          title: "实收数量",
          dataIndex: "checkNumber",
          key: "checkNumber",
          scopedSlots: { customRender: "checkNumber" },
          align: "center"
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
          customRender: (val,row,index)=>{
            return {
              children: (this.curRow.state == 0  || this.curRow.state == 4) ? <a-textarea onChange={(val)=>{this.remarkChange(val,row)}} v-model={this.curRow.remark} placeholder="请输入备注" auto-size={{minRows: this.curRow.details.length * 3}}/> : <span>{this.curRow.remark}</span>,
              attrs:{
                rowSpan:index == 0 ? this.curRow.details.length : 0
              }
            }
          },
        }
      ],
      columns: [
        {
          title: "收货单编号",
          dataIndex: "checkNum",
          key: "checkNum"
        },
        {
          title: "发货单位",
          dataIndex: "supplierName",
          key: "supplierName"
        },
        {
          title: "订单号",
          dataIndex: "orderFormid",
          key: "orderFormid"
        },
        {
          title: "下单时间",
          dataIndex: "orderCreateTime",
          key: "orderCreateTime"
        },
        {
          title: "状态",
          dataIndex: "state",
          key: "state",
          scopedSlots: { customRender: "state" }
        },
        {
          title: "操作",
          dataIndex: "operation",
          key: "operation",
          scopedSlots: { customRender: "operation" }
        }
      ],
      page: 1,
      activeName: this.$route.query.activeName || "first",
      keyword: "",
      state: this.$route.query.state || "",
      cancelOrderShow: false,
      refund: false,
      index: null,
      cancelId: null,
      confirmId: null,
      confirmShow: false,
      deleteId: null,
      deleteOrderShow: false,
      checked: false,
      orderData: {},
      total: 0,
      backList: [],
      productIds: [],
      productData: [],
      curRow: { needPayAmount: 0, details: [] },
      flag: true,
      loading: false
    };
  },
  computed:{
    curRowFinalPrice(){
      let supplyAmount = 0;
      let checkAmount = 0;
      this.curRow.details.map(item=>{
        checkAmount += Number(item.checkAmount) //实收小计
        supplyAmount += Number(item.amount) //应收小计
      });
      return checkAmount - supplyAmount
    }
  },
  mounted() {
    this.getReceiveList();
    if(this.$route.query.checkId){
      this.showDialog({checkId:this.$route.query.checkId})
    }
  },
  methods: {
    // 获取订单未读
    getSelfCount() {
      let self = this;
      let params = {
        url:api.getSelfCount,
        method: "GET",
        data: {}
      };
      self.sendReq(params, res => {
        if (res.code == "200" || res.code == '') {
          res.data.checkStateCounts.map(item=>{
            this.checkStateCounts[item.state] = item.stateNum
          })
          this.$forceUpdate()
        }
      });
    },
    remarkChange(val,row){
      this.curRow.remark = val.srcElement.value
    },
    onChange(page,pageSize){
      this.formInline.page = page;
      this.getReceiveList()
    },
    //     getReceiveList:`${BASEURL}/order/check/getAll`,//查询收货单
    // getReceiveDetail:`${BASEURL}/order/check/getById`,//查询收货单详情
    // receiveGoToPay:`${BASEURL}/order/check/goToPay`,//收货单账期付款补款
    // receiveCheckOrder:`${BASEURL}/order/check/checkOrder`,//验收收货单
    computedTotal() {
      //计算总计
      let total = 0;
      let checkTotal = 0;
      this.curRow.details.map(item => {
        total += Number(item.amount);
        checkTotal += Number(item.checkAmount);
      });
      this.curRow.needPayAmount = (total - checkTotal).toFixed(2);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    handleChange(val, row) {
      row.checkNumber = val;
      row.checkAmount = (Number(val) * Number(row.unitPrice)).toFixed(2);
      this.computedTotal();
    },
    handleOk() {
      // <!-- 状态0待收货 1待审核 2待付款 3已完成 默认为0 -->
      if (this.curRow.state == 0  || this.curRow.state == 4) {
        //待确认
        this.sendReq(
          {
            url: api.receiveCheckOrder,
            method: "POST",
            data: {
              checkId: this.curRow.checkId,
              checkList: this.curRow.details.map(item => {
                return {
                  checkNumber: item.checkNumber,
                  checkSkusId: item.checkSkusId
                };
              }),
              remark: this.curRow.remark
            }
          },
          res => {
            this.$message({
              message: res.message || "操作成功!",
              type: "success"
            });
            this.getReceiveList();
            this.visible = false;
          }
        );
      } else if (this.curRow.state == 2) {
        let _this = this;
        this.$confirm({
          title: "补款",
          content: h => <div>确认后将使用您的账期额度付款 <span style="color:#ff4747;">¥{Math.abs(Number(this.curRowFinalPrice)).toFixed(2)}</span></div>,
          onOk() {
            _this.sendReq(
              {
                url: api.receiveGoToPay,
                method: "POST",
                data: {
                  checkId: _this.curRow.checkId
                }
              },
              res => {
                if(res.code == '200' || res.code == ''){
_this.$message({
                  message: res.message || "操作成功!",
                  type: "success"
                });
                _this.getReceiveList();
                _this.visible = false;
                }else{
                  _this.$message({
                  message: res.message,
                  type: "error"
                });
                }
                
              }
            );
          },
          onCancel() {}
        });
      } else {
        this.visible = false;
      }
    },
    showDialog(row) {
      this.sendReq(
        {
          url: api.getReceiveDetail,
          method: "POST",
          data: { checkId: row.checkId }
        },
        res => {
          this.curRow = {
            ...row,
            ...res.data
          };
          this.visible = true;
          this.computedTotal();
        }
      );
    },
    // 获取订单列表
    getReceiveList() {
      //先获取订单数量
      this.getSelfCount();
      let self = this;
      self.loading = true;
      let params = {
        url: api.getReceiveList,
        method: "POST",
        data: { ...this.formInline }
      };
      self.sendReq(params, res => {
        if (res.code === "200") {
          self.receiveList = res.data.list;
          self.total = res.data.total;
          if (self.receiveList.length) {
            this.flag = true;
          } else {
            this.flag = false;
          }
          self.loading = false;
        } else {
          self.$message({
            message: res.message,
            type: "warning"
          });
          self.loading = false;
        }
      });
    },
    // 搜索订单
    searchOrder() {
      this.activeName = "first";
      this.state = "";
      this.page = 1;
      this.getReceiveList();
    },
    // 取消订单
    cancelOrder() {
      let self = this;
      let params = {
        url: api.cancelOrder,
        method: "PUT",
        data: {
          orderId: self.cancelId
        }
      };
      self.sendReq(params, res => {
        if (res.code === "200") {
          self.$message({
            message: "订单取消成功",
            type: "success"
          });
          self.cancelOrderShow = false;
          self.getReceiveList();
        } else {
          self.$message({
            message: res.message,
            type: "warning"
          });
        }
      });
    },
    // 删除订单
    deleteOrder() {
      let self = this;
      let params = {
        url: api.deleteOrder,
        method: "DELETE",
        data: {
          orderId: self.deleteId
        }
      };
      self.sendReq(params, res => {
        if (res.code === "200") {
          self.$message({
            message: "订单删除成功",
            type: "success"
          });
          self.deleteOrderShow = false;
          self.getReceiveList();
        } else {
          self.$message({
            message: res.message,
            type: "warning"
          });
        }
      });
    },
    // 确认收货
    confirm() {
      let self = this;
      let params = {
        url: api.confirm,
        method: "PUT",
        data: {
          orderId: self.confirmId
        }
      };
      self.sendReq(params, res => {
        if (res.code === "200") {
          self.$message({
            message: "确认收货成功",
            type: "success"
          });
          self.confirmShow = false;
          self.getReceiveList();
        } else {
          self.$message({
            message: res.message,
            type: "warning"
          });
        }
      });
    },
    // 打开确认收货弹窗
    isConfirm(id) {
      this.confirmId = id;
      this.confirmShow = true;
    },
    // 打开删除订单弹窗
    isDelete(id) {
      this.deleteOrderShow = true;
      this.deleteId = id;
      // console.log(id)
    },
    // 切换订单列表
    handleClick(event) {
      if (event.index === "0") {
        this.formInline.state = "";
      } else {
        if (event.index === "1") {
          this.formInline.state = 0;
        } else if (event.index === "2") {
          this.formInline.state = 1;
        } else if (event.index === "3") {
          this.formInline.state = 2;
        } else if (event.index === "4") {
          this.formInline.state = 3;
        } else if (event.index === "5") {
          this.formInline.state = 4;
        }
      }
      this.formInline.page = 1;
      this.getReceiveList();
    },
    // 打开取消订单弹窗
    isCancel(id) {
      this.cancelOrderShow = true;
      this.cancelId = id;
    },
    // 关闭退货弹窗
    handleClose() {
      this.backList = [];
      this.checked = false;
      this.productIds = [];
      this.refund = false;
    },
    // 关闭删除订单弹窗
    handleClose3() {
      this.deleteOrderShow = false;
      this.deleteId = null;
    },
    // 关闭取消订单弹窗
    handleClose1() {
      this.cancelOrderShow = false;
      this.cancelId = null;
    },
    // 关闭确认收货弹窗
    handleClose2() {
      this.confirmShow = false;
      this.confirmId = null;
    },
    // 打开退货弹窗
    isRefund(data) {
      let temp = [];
      data.skus.forEach(i => {
        if (i.ifAfter) {
          temp.push(i);
        }
      });
      this.backList = temp;
      this.orderData = data;
      this.refund = true;
    },
    // 选择退货商品
    select(id) {
      if (this.productIds.indexOf(id) === -1) {
        this.productIds.push(id);
      } else {
        this.productIds.splice(this.productIds.indexOf(id), 1);
      }
      if (this.productIds.length === this.backList.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    changeBox(val) {
      if (val) {
        this.productIds = [];
        this.backList.map(item => {
          this.productIds.push(item.productId);
        });
        // console.log(this.productIds)
      } else {
        this.productIds = [];
      }
    },
    // 跳转到申请售后页面
    toAfterSale() {
      if (this.productIds.length === 0) {
        return this.$message.warning("请先选择需要申请售后的商品");
      }
      var productData = [];
      for (var k in this.productIds) {
        for (var i in this.orderData.skus) {
          if (this.orderData.skus[i].productId === this.productIds[k]) {
            productData.push(this.orderData.skus[i]);
          }
        }
      }
      var paramsData = this.orderData;
      paramsData.skus = productData;
      this.$router.push({
        path: "/afterSale",
        query: {
          orderData: JSON.stringify(paramsData),
          state: 1
        }
      });
    },
    // 分页器跳转
    handleCurrentChange(val) {
      this.page = val;
      this.getReceiveList();
    }
  }
};
</script>
<style lang="scss">
.paginationBox{
  text-align: center;
  margin-top: 20px;
}
.ant-btn {
  border: 1px solid #d9d9d9 !important;
}
.ant-btn-primary,
.ant-btn-primary:active,
.ant-btn-primary.active {
  border: none !important;
}
.specialBadge{
    .el-badge__content{
      top: 16px !important;
    }
  }
</style>
<style lang="scss" scoped>
.miniLabel {
  font-size: 14px;
  color: rgba(96, 98, 102, 1);
  display: inline-block;
  height: 40px;
}
.miniText {
  font-size: 14px;
  color: #333333;
  display: inline-block;
  height: 40px;
}
.moneyInfo {
  padding-top: 20px;
  & > span:nth-child(2n) {
    color: rgba(96, 98, 102, 1);
    font-size: 14px;
    margin-right: 20px;
  }
  & > span:nth-child(2n + 1) {
    font-size: 14px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  & > span:nth-child(2) {
    font-size: 18px;
    color: rgba(255, 71, 71, 1);
  }
}
.peopleInfo {
  display: flex;
  align-items: center;
  height: 60px;
  & > span {
    margin-right: 14px;
  }
  & > div {
    margin-right: 32px;
  }
  & > input {
    width: 167px;
    border: 1px solid #dcdfe6;
  }
}
.myOrder {
  width: 100%;
  padding: 24px 39px;
  .top {
    width: 100%;
    font-size: 14px;
    box-sizing: border-box;
    position: relative;
    >>> .el-tabs {
      .el-tabs__header {
        border: 1px solid #e5e5e5;
        margin-bottom: 30px;
        height: 56px;
      }
      .el-tabs__nav {
        margin-left: 20px;
        height: 56px;
      }
      .el-tabs__item {
        height: 56px;
        line-height: 56px;
      }
      .el-tabs__nav-wrap::after {
        height: 0;
      }
    }
    >>> .search {
      font-size: 12px;
      margin-right: 20px;
      display: flex;
      position: absolute;
      height: 56px;
      display: flex;
      align-items: center;
      top: 0;
      right: 0;
      .el-input {
        flex: 3;
        border-radius: 0;
        .el-input__inner {
          border-radius: 0;
        }
        .el-input-group__append {
          border-radius: 0;
          border-left: 0;
          .el-button {
            border-left: 0;
          }
        }
      }
      .el-select {
        flex: 1;
        border-radius: 0;
        height: 40px;
      }
    }
  }
  >>> .cancelOrder,
  .confirm {
    .el-dialog__body {
      display: flex;
      justify-content: center;
      div {
        text-align: center;
        p {
          font-size: 16px;
        }
      }
    }
    .el-dialog__footer {
      .leftBtn {
        background-color: #ff7800;
        border: 1px solid #ff7800;
        color: #ffffff;
        border-radius: 0;
      }
      .rightBtn {
        color: #ff7800;
        border: 1px solid #ff7800;
        background-color: #ffffff;
        box-sizing: border-box;
        border-radius: 0;
      }
    }
  }
  >>> .refund {
    .el-dialog__body {
      display: flex;
      justify-content: center;
      background-color: #f8f8f8;
      padding: 20px 75px;
      box-sizing: border-box;
      .box {
        display: flex;
        flex-wrap: wrap;
        overflow-x: auto;
        height: 350px;
        width: 100%;
        text-align: center;
      }
      .el-checkbox {
        display: flex;
        align-items: center;
      }
      .el-checkbox__input {
        line-height: 18px;
      }
      .el-checkbox__label {
        font-size: 18px;
      }
      .back {
        width: 208px;
        padding: 10px 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        text-align: center;
        flex-direction: column;
        background-color: #ffffff;
        margin: 0 20px 20px 0;
        border: 1px solid transparent;
        position: relative;
        img {
          width: 171px;
          height: 171px;
        }
        .choice {
          width: 30px;
          height: 30px;
          position: absolute;
          bottom: 0;
          right: 0;
          display: none;
        }
      }
      .back:nth-of-type(3n) {
        margin-right: 0;
      }
      .backActive {
        border: 1px solid #ff7800;
        .choice {
          display: block;
        }
      }
    }
    .el-dialog__footer {
      .leftBtn {
        background-color: #ff7800;
        border: 1px solid #ff7800;
        color: #ffffff;
        border-radius: 0;
      }
      .rightBtn {
        color: #ff7800;
        border: 1px solid #ff7800;
        background-color: #ffffff;
        box-sizing: border-box;
        border-radius: 0;
      }
    }
  }
}
.sub-main {
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/receipt/receipt.vue